import { Component, inject, ViewEncapsulation } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslatePipe,
    RouterLink,
    CommonModule
  ]
})
export class PrivacyPolicyComponent {
  effectiveDate = '2025-07-21';
  constructor(public translateService: TranslateService) {}
}
